import { Outlet } from "react-router-dom";

const DebitNotesParentPage = () => {
    return <Outlet />
}
export default DebitNotesParentPage;
